'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _Anchorman = require('../components/Anchorman');

var _Anchorman2 = _interopRequireDefault(_Anchorman);

var _actions = require('../../../store/reportManagement/actions');

var _selectors = require('../../../store/reportManagement/selectors');

var _constants = require('../../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    savedReports: (0, _extends3.default)({}, state.reportManagement.savedReports, {
      data: (0, _selectors.buildPlatformSpecificReports)(state),
      maxFavourites: _constants.SAVED_REPORT_MAX_FAVOURITES
    }),
    platform: state.session.currentPlatformType,
    userId: state.session.user.id,
    createReportFailMessage: state.reportManagement.global.createReportFailMessage,
    isPackage: state.session.isPackage
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    savedReportActions: {
      onSelect: (0, _redux.bindActionCreators)(_actions.savedReportsOnSelect, dispatch),
      onFav: (0, _redux.bindActionCreators)(_actions.savedReportsOnFavourite, dispatch),
      onDelete: (0, _redux.bindActionCreators)(_actions.savedReportsOnDelete, dispatch),
      onDuplicate: (0, _redux.bindActionCreators)(_actions.savedReportsOnDuplicate, dispatch)
    },
    removeGlobalReportFailMessage: (0, _redux.bindActionCreators)(_actions.savedReportsOnDuplicateFail, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Anchorman2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/anchorman/lib/modules/Anchorman/containers/AnchormanContainer.js
// module id = 2704
// module chunks = 1